<template>
  <div class="card">
    <div class="card-header" data-background-color="magenta">
      <div class="row">
        <div class="col-md-5">
          <h4 class="title"></h4>
        </div>
      </div>
    </div>

    <div class="form-group">
      <div class="row">
        <div class="col-md-offset-5">
          <button
            type="button"
            @click="enable_map_link"
            class="btn btn-primary btn-sm"
          >Generar enlace</button>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-7 col-md-offset-2">
          <a v-if="showLink" :href="mapLink" target="_blank" class="alert-link">{{mapLink}}</a>
        </div>
        <div class="col-md-1">
          <button
            v-if="showLink"
            type="button"
            class="btn btn-secondary btn-sm"
            v-clipboard:copy="mapLink"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
            data-toggle="popover"
            data-container="body"
            data-placement="right"
            data-content="Copiado"
          >Copiar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mapLink: {
      type: String,
      default: ""
    },
    showLink: {
      type: Boolean,
      defualt: false
    },
    copying: {
      type: Boolean,
      defualt: false
    }
  },

  methods: {
    enable_map_link: function() {
      this.$emit("enable-map-link");
    },

    onCopy: function() {
      return;
    },

    onError: function() {
      alert("Error al copiar a la papelera");
    }
  }
};
</script>

<style>
#gg {
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// MapLink.vue?796f1d5e